import type { ReactNode } from 'react';
import { ChevronDown, ChevronUp } from '../../components/ui/icons';
import { Skeleton } from '../../components/ui/bits';
import { cn } from '../../lib/cn';
import { profileCard } from './tokens';

/** League-scoped stat tile — optional vs-you delta when scouting another player. */
export function StatTile({
  value,
  label,
  delta,
  formatDelta = (n: number) => String(n),
  accent,
  loading,
  inset = false
}: {
  value: ReactNode;
  label: string;
  delta?: number;
  formatDelta?: (n: number) => string;
  accent?: boolean;
  loading?: boolean;
  /** Render inside a StatGrid panel — no outer border or shadow. */
  inset?: boolean;
}) {
  const up = (delta ?? 0) > 0;
  return (
    <div className={cn(inset ? 'p-4' : cn('p-4', profileCard))}>
      {loading ? (
        <Skeleton className="h-[26px] w-12" />
      ) : (
        <div
          className={cn(
            'num animate-fade-in text-[26px] font-extrabold leading-none tracking-tight',
            accent ? 'text-accent-ink' : 'text-ink'
          )}
        >
          {value}
        </div>
      )}
      <div className="mt-2 text-[11.5px] font-semibold text-ink2">{label}</div>
      {!loading &&
        delta != null &&
        (delta === 0 ? (
          <div className="mt-[6px] text-[10px] font-extrabold text-ink3">level with you</div>
        ) : (
          <div
            className={cn(
              'mt-[6px] inline-flex items-center gap-[1px] text-[10px] font-extrabold',
              up ? 'text-accent-ink' : 'text-danger'
            )}
          >
            {up ? (
              <ChevronUp width={9} height={9} strokeWidth={3.4} />
            ) : (
              <ChevronDown width={9} height={9} strokeWidth={3.4} />
            )}
            {formatDelta(Math.abs(delta))} vs you
          </div>
        ))}
    </div>
  );
}
